import { Image } from 'image-js';
import Id from './IdFactory';
import A from './ActionCreators';
import fetch from 'cross-fetch';
import { isCLI } from './versionConfig';

const isImageStack = Array.isArray;

function getImageId(iiFilename, iiStackItem, imageIds){
  if( imageIds && imageIds[iiFilename] && imageIds[iiFilename][iiStackItem] ){
    return imageIds[iiFilename][iiStackItem];
  }
  return Id();
}

async function getFinalUrl(data){

  let dataURL = data.toDataURL("image/png")
  return await fetch(dataURL).then(res => {
    return res.blob()
  }).then(blob => {
    let finalUrl = URL.createObjectURL(blob);
    console.log({finalUrl});
    return finalUrl;
  })

}


export default function uploadFiles(args){
  return async function(dispatch,getState){


    let { urls,filenames, imageSetIds=[], imageIds=[] } = args;

    return Promise.all(urls.map(async (url,iiFilename) => {

      let imageSetId = imageSetIds[iiFilename]||Id();
      let imageUploadData = [];
      let filename = filenames[iiFilename];


      if( process.env.NODE_ENV === 'development' && isCLI() ){
        url =  '../test/files/'+filenames[iiFilename];
      }

      console.log("_________URL_______",{url});


      await Image.load(url).then((output) => {

        let imageStack = [ output ].flat();

          imageStack.forEach(async (image,iiStackItem) => {
            let imageId = getImageId(iiFilename,iiStackItem,imageIds);
            let { width, height, colorModel, size, alpha } = image;

            let localFilename = filename+" C"+iiStackItem;
            let url = await getFinalUrl(image);
            let args = {
              urls:[url],
              imageSetIds:[imageSetId],
              imageIds:[imageId],
              uploadWidths:[width],
              heights:[height/width],
              filenames:[localFilename],
              readIntoMemory:false,
              //storageLocation:"fake",
              grayscale:[colorModel === "GREY"],
            }

            dispatch(A.startImageUploads(args));

          })
      }).catch(error => {
        debugger;
        throw Error(error);
      })

    }))

    





    //1. direct the file to the server
    //2. process the file and return an object
    //3. that object will contain:
    //  - required metadata
    //  - images
    //4.



  }
}
